import { useTranslation } from 'react-i18next';

import type { QuotationStatus } from '~/api/quotations/types';
import type { IconName } from '~/components/Icon/Icon';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<QuotationStatus, StatusEntry> = {
  Approved: { icon: 'Check', status: 'success' },
  Draft: { icon: 'Edit', status: 'neutral' },
  Expired: { icon: 'HourglassBottom', status: 'danger' },
  Rejected: { icon: 'CloseSmall', status: 'danger' },
  Sent: { icon: 'Mail', status: 'info' },
};

type Props = {
  status: QuotationStatus;
};

export const QuotationStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];

  const { t } = useTranslation(['quotations']);

  return <StatusTag icon={icon} label={t(`quotations:overview.columns.status.options.${status}`)} status={statusTheme} />;
};
